import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AdminSidePanel from "./AdminSidePanel";
import { Link } from "react-router-dom";
import { FaPlusCircle } from "react-icons/fa";
import { useCookies } from "react-cookie";
import axios from "axios";

function AdminAnnouncements() {

  const [cookies, removeCookie] = useCookies(["Authorization"]);

  const [announcementList, setAnnouncementList] = useState([]);

  useEffect(() => {
    axios.get("/api/announcement/load_list", { headers: cookies }).then((res) => {
      console.log("res.data in adminannouncements is", res.data);
      setAnnouncementList(res.data.records);
    });
  }, []);


  return (
    <>
      <main className="admin-panel">
        <div className="row">
          <div className="col-lg-2">
            <AdminSidePanel />
          </div>
          <div className="col-lg-9">
            <div className="admin-sitemap">
              Admin Panel {">"} Site Manager {">"} Announcements
            </div>
            <br></br>
            <br></br>
            {/* Announcements */}
            <div className="col-lg-12">
              <div className="section-heading">
                <h2 className="sec__title font-size-24">Announcements</h2>
                <Link to="/admin-addannouncement" className="admin-add">
                  <FaPlusCircle />
                </Link>
              </div>
              <div className="ledger-details-payment table-responsive">
                <table className="table mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Announcement</th>
                      <th scope="col">Details</th>
                      <th scope="col">Image</th>
                      <th scope="col">Status</th>
                      <th scope="col">Manage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {announcementList
                      .reverse()
                      .map((item, index) => (
                        <tr>
                          <td>{item.name}</td>
                          <td>{item.description}</td>
                          <td>{item.featuredPhoto}</td>
                          <td>{item.status}</td>
                          <td>
                            <Link to="/admin-announcements">View</Link> |{" "}
                            <Link to="/admin-announcements">Edit</Link> |{" "}
                            <Link to="/admin-announcements">Delete</Link>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <Link to="/admin-announcements" className="admin-seeall">
                Page 1 of 1 Next {">>"}
              </Link>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
          </div>
        </div>
      </main>
    </>
  );
}

export default AdminAnnouncements;
